import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import WhatsappMarketingContent from './WhatsappMarketingContent';

const WhatsappMarketing = () => (
  <>
    <Helmet>
      <title>WhatsApp Marketing Platform &amp; Campaigns | HAWKTRION</title>
      <meta name="description" content="Plan WhatsApp marketing campaigns with audience segments, approved templates, automation, and CRM integrations. Manage business messaging with HAWKTRION." />
      <meta name="keywords" content="WhatsApp marketing platform, WhatsApp marketing campaigns, WhatsApp campaign management" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-marketing/" />
      <meta property="og:title" content="WhatsApp Marketing Platform &amp; Campaigns | HAWKTRION" />
      <meta property="og:description" content="Plan WhatsApp marketing campaigns with audience segments, approved templates, automation, and CRM integrations. Manage business messaging with HAWKTRION." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-marketing/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp Marketing Platform &amp; Campaigns | HAWKTRION" />
      <meta name="twitter:description" content="Plan WhatsApp marketing campaigns with audience segments, approved templates, automation, and CRM integrations. Manage business messaging with HAWKTRION." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp Marketing Campaigns for Business" hideCta>
      <WhatsappMarketingContent />
    </SeoLandingPage>
  </>
);

export default WhatsappMarketing;